import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import {TerritoryService} from "./geolocation/territory.service";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private territoryService: TerritoryService = inject(TerritoryService);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly document = inject(DOCUMENT);


  public changeTheme() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const territoryCodeFromUrl = this.territoryService.getTerritoryCodeFromUrl();

    this.applyTerritoryTheme(territoryCodeFromUrl);
  }

  public changeThemeByTerritory(territoryCode: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.applyTerritoryTheme(territoryCode);
  }

  private applyTerritoryTheme(territoryCode: string): void {
    const territoryStyles = this.document.getElementById("territory-styles") as HTMLLinkElement | null;
    if (!territoryStyles) {
      return;
    }

    this.document.documentElement.setAttribute('data-territory', territoryCode);
    territoryStyles.setAttribute("href", "/assets/xplorer/" + territoryCode + "/styles.css");

    // Keep territory stylesheet last in <head> so theme vars override defaults from styles.css.
    const headElement = this.document.head;
    if (territoryStyles.parentElement === headElement) {
      headElement.appendChild(territoryStyles);
    }
  }

}
